import * as Yup from 'yup';

// Wspólne reguły walidacji – te same komunikaty we wszystkich formularzach.
// Reguła hasła jest zgodna z backendem (reset hasła: 6–20 znaków, cyfra i znak specjalny).

export const PASSWORD_PATTERN = /^(?=.*[0-9])(?=.*[!@#$%^&*]).{6,20}$/;
export const PASSWORD_HINT = '6–20 znaków, w tym cyfra i znak specjalny (!@#$%^&*)';

export const EMAIL_REQUIRED = 'Adres e-mail jest wymagany';
export const EMAIL_INVALID = 'Podaj prawidłowy adres e-mail';
export const FIELD_REQUIRED = 'Pole wymagane';

export const emailSchema = Yup.string().trim().email(EMAIL_INVALID).required(EMAIL_REQUIRED);

export const passwordSchema = Yup.string()
    .matches(PASSWORD_PATTERN, `Hasło musi mieć ${PASSWORD_HINT}`)
    .required('Hasło jest wymagane');

export const confirmPasswordSchema = (ref = 'password') => Yup.string()
    .oneOf([Yup.ref(ref)], 'Hasła muszą być identyczne')
    .required('Powtórz hasło');
